import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/provide/auth.service';
import { CommonService } from 'src/app/provide/common.service';
declare var $
@Component({
    selector: 'app-booking-data-view',
    templateUrl: './booking-data-view.component.html',
    styleUrls: ['./booking-data-view.component.scss'],
    standalone: false
})
export class BookingDataViewComponent implements OnInit {
  data: any
  qtyA: any
  serviceData: any
  idOfAddress: any
  loggedInUserType: any;
  headingName:any ='Booking Detail'
  linkerRouteItems:any =[
    {name:'Home',route: '/home'},
    {name:'Account',route:'/customer-profile'},
    {name:'Bookings',route:'/customer-service-request-list-table'},
    {name:'View',route:'/customer-booking-details-view'}

  ]
  // constructor(private activatedroute: ActivatedRoute, public authService: AuthService, public commonService: CommonService, private router: Router) {
  //   this.activatedroute.queryParams.subscribe((res: any) => {
  //     this.data = JSON.parse(res.data);
      
      
  //     // this.idOfAddress =res.idOfAddress   
  //   })
  // }
  constructor(
    private activatedroute: ActivatedRoute, 
    public authService: AuthService, 
    public commonService: CommonService, 
    private router: Router
  ) {
    // Replace this:
    // this.activatedroute.queryParams.subscribe((res: any) => {
    //   this.data = JSON.parse(res.data);
  
    // With this:
    if (history.state.data) {
      this.data = history.state.data;
    } else {
      // Retrieve data from localStorage if state data is not available
      const storedData = localStorage.getItem('bookingData');
      this.data = storedData ? JSON.parse(storedData) : null;
    }
    
    // Extract transaction info if it exists
    if (this.data) {
      if (this.data.transaction) {
        this.data.transactionId = this.data.transaction.trxId || this.data.transaction._id;
        this.data.transactionMethod = this.formatPaymentMethod(this.data.transaction.transactionMethod);
      } else if (this.data.transactions && this.data.transactions.length > 0) {
        // If transactions is an array, use the first one
        const transaction = this.data.transactions[0];
        this.data.transactionId = transaction.trxId || transaction._id;
        this.data.transactionMethod = this.formatPaymentMethod(transaction.transactionMethod);
      }
    }
  }

  ngOnInit(): void {
    this.authService.loggedInUserType.subscribe((res: any) => {
      this.loggedInUserType = res

    })
    this.loggedInUserType = this.authService.checkUserTypeLoggedIn()
    this.viewOpenOrder()
  }

  /**
   * Format the booked date and time in a user-friendly way
   * @param date The booking creation date
   * @returns Formatted date and time string
   */
  formatBookedDateTime(date: any): string {
    if (!date) return '--';
    
    const formattedDate = new Date(date).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
    
    const formattedTime = new Date(date).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
    
    return `${formattedDate} ${formattedTime}`;
  }

  /**
   * Format the service date and time in a user-friendly way
   * @param date The service date
   * @param slot The time slot string or array (e.g. "9:00AM - 10:00AM")
   * @returns Formatted date and time string
   */
  formatServiceDateTime(date: any, slot: any): string {
    if (!date) return '--';
    
    const formattedDate = new Date(date).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
    
    // Handle case when slot is an array
    let slotValue = '';
    if (slot) {
      if (Array.isArray(slot)) {
        slotValue = slot.length > 0 ? slot[0] : '';
      } else {
        slotValue = slot;
      }
    }
    
    return `${formattedDate} ${slotValue}`;
  }

  viewOrderData: any = []
  orderDataDetials = {
    booking : false,
    ontheway : false,
    execution : false,
    completed : false
  }
  feedBackData: any
  isFeedbackDataSubmited = false
  viewOpenOrder() {
    let url = `order/v2/viewOrder?orderId=${this.data._id}`
    this.commonService.showSpinner();
    this.commonService.getApi(url, 1).subscribe((res: any) => {
      if (res["responseCode"] == 200) {
        this.commonService.hideSpinner();
        let result = res.result
        this.orderDataDetials = res.result
        
        // Store transaction data if available
        if (result.transaction) {
          console.log('Transaction data found in response:', result.transaction);
          this.data.transactionId = result.transaction.trxId || result.transaction._id;
          this.data.transactionMethod = this.formatPaymentMethod(result.transaction.transactionMethod);
        } else if (result.transactions && result.transactions.length > 0) {
          // If transactions is an array, use the first one
          console.log('Transactions array found in response:', result.transactions);
          const transaction = result.transactions[0];
          this.data.transactionId = transaction.trxId || transaction._id;
          this.data.transactionMethod = this.formatPaymentMethod(transaction.transactionMethod);
        } else {
          // If no transaction data found in the response, try to fetch it separately
          console.log('No transaction data found in response, fetching separately');
          this.fetchTransactionData();
        }
        
       if(result.serviceStatus == 'BOOKING_RECEIVED'){
        this.orderDataDetials.booking = true
       }
       
       if(result.serviceStatus == 'ONTHEWAY'){
        this.orderDataDetials.booking = true
        this.orderDataDetials.ontheway = true
       }
       if(result.serviceStatus == 'EXECUTION'){
        this.orderDataDetials.booking = true
        this.orderDataDetials.ontheway = true
        this.orderDataDetials.execution = true
       }
       if(result.serviceStatus == 'COMPLETED'){
        this.orderDataDetials.booking = true
        this.orderDataDetials.ontheway = true
        this.orderDataDetials.execution = true
        this.orderDataDetials.completed = true
       }

      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res["responseMessage"])
      }
    }, (err) => {
      this.commonService.hideSpinner();
      this.commonService.errorToast("Server error")
    });
  }
  
  /**
   * Fetch transaction data separately if not included in the order response
   */
  fetchTransactionData() {
    if (!this.data || !this.data._id) return;
    
    let url = `order/viewOrderTransaction?orderId=${this.data._id}`;
    this.commonService.getApi(url, 1).subscribe(
      (res: any) => {
        if (res && res.responseCode == 200 && res.result) {
          console.log('Transaction data fetched separately:', res.result);
          this.data.transactionId = res.result.trxId || res.result._id;
          this.data.transactionMethod = this.formatPaymentMethod(res.result.transactionMethod);
        } else {
          console.log('No transaction data found in separate request');
        }
      },
      (err) => {
        console.error('Error fetching transaction data:', err);
      }
    );
  }

  getPrice(e: any) {
    return this.commonService.getPrice(e)
  }
  date: any = Date

  getAddedDate(createdAt: string, days: number) {
    let date = new Date(createdAt).setDate(new Date(createdAt).getDate() + 3);
    return date
  }

  /**
   * Format the payment method for display
   * @param method The payment method string from the API
   * @returns Formatted payment method string
   */
  formatPaymentMethod(method: string): string {
    if (!method) return 'N/A';
    
    // Common payment methods
    if (method.includes('YOCO')) return 'YOCO';
    if (method.includes('WALLET')) return 'WALLET';
    if (method.includes('PAYFAST')) return 'PAYFAST';
    if (method.includes('CARD')) return 'CARD';
    
    return method; // Return original if not matched
  }
  
}
